import { type FC, useState } from "react";
import BrandLogo from "../../components/BrandLogo";
import { Button } from "../../components/ui/button";
import { gluceraAssessmentCta } from "../../utils/gluceraTypography";
import { useNavigate } from "react-router-dom";
import GluceraNavigationRoutes from "../../utils/navigationRoutes";
import SessionStorageHelper from "../../utils/sessionStorageHelper";

const AddMedicationPage: FC = () => {
  const navigate = useNavigate();
  const [hasMedicationAdded, setHasMedicationAdded] = useState<boolean>(false);

  const handleNext = () => {
    if (hasMedicationAdded) {
      // User wants to add medications, navigate to medication form
      navigate("/glucera" + GluceraNavigationRoutes.ADD_MEDICATIONS);
    } else {
      // User has no medications, save empty array and continue
      SessionStorageHelper.saveField("medication_details", []);
      navigate("/glucera" + GluceraNavigationRoutes.WEIGHT_LOSS);
    }
  };

  return (
    <div className="h-screen w-screen overflow-hidden bg-background">
      <div className="mx-auto flex h-full w-full max-w-md flex-col">
        {/* Header */}
        <div className="space-y-4 px-4 pb-4 pt-safe">
          <BrandLogo />

          {/* Assessment Progress */}
          <p className="text-center text-subhead text-muted-foreground">
            Assessment 6 of 11
          </p>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto px-6 py-4">
          <div className="mb-6 space-y-2">
            <h1 className="text-center text-large-title font-bold text-foreground sm:text-4xl">
              Your Current Medications
            </h1>
            <p className="text-center text-subhead text-muted-foreground">
              Add your current medications (optional)
            </p>
          </div>

          <button
            className={`w-full rounded-xl border-2 px-4 py-4 text-title3 font-semibold transition-all ${
              hasMedicationAdded
                ? "border-primary bg-primary/5 text-foreground"
                : "border-border bg-card text-foreground hover:border-primary/50"
            }`}
            onClick={() => setHasMedicationAdded(!hasMedicationAdded)}
          >
            Add Medication
          </button>
        </div>

        {/* Footer Button */}
        <div className="pb-safe border-t p-4">
          <Button
            onClick={handleNext}
            className={gluceraAssessmentCta}
          >
            Next
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AddMedicationPage;
